module.exports = __webpack_public_path__ + "static/media/logoBlack.74498b4e.svg";